module.exports = __webpack_public_path__ + "fonts/square-arrow-right-up-down-red.svg";